import { Component, OnInit ,Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-passwordnew',
  templateUrl: './passwordnew.component.html',
  styleUrls: ['./passwordnew.component.scss']
})
export class PasswordnewComponent implements OnInit {

    grupoVal = new FormGroup({
      password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(15)])),
      password2: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(15)]))
    });

  constructor(
  	public descargaDialog: MatDialogRef<PasswordnewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    private snackbar: MatSnackBar,
    public localSave:LocalSaveService,
  	) { }

  ngOnInit() {
    
  }

    public cerrar(): void {
		  let response = {
			  param:0
		  }
      this.descargaDialog.close(response);
    
  	}

    public aceptar(){
      this.spinner.show()
      this.gateway.save('cambiapass', {PASS:this.grupoVal.controls.password.value, IDAGENTE:this.data.agente.idagente}).then((result) => {
        this.spinner.hide();
        this.localSave.set('nuevoUserPass',1);
        this.snackbar.open('Contraseña cambiada exitosamente.', 'Cerrar', {
          duration: 3000,
        });
        this.descargaDialog.close({param:1});    
      }).catch(function (e) {
        // Error handled silently
      });
    }

}
